import { Component, OnInit } from '@angular/core';
import { CustomListEditorService } from '../../services/custom-list-editor.service';
import { FavoriteList } from '../../../../../custom-locations-store/src/lib/models/favorite-locations.types';
import { Store } from '@ngrx/store';
import {
  changeList,
  copyList,
  deleteList,
  getFavoriteLists,
  loadCities,
  loadLists,
} from '@firebird-web/custom-locations-store';
import { CustomListDataService } from '../../services/custom-list-data.service';
import { ImportCustomListsNetworkingService } from '../../services/import-custom-lists-networking.service';
import { switchMap } from 'rxjs';
import { ToastComponent } from 'libs/shared/ui/src/lib/components/toast/toast.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ImportListDialogComponent } from '../import-dialog/import-list-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'firebird-web-favorite-locations',
  templateUrl: './favorite-locations.component.html',
  styleUrls: ['./favorite-locations.component.scss'],
  providers: [ImportCustomListsNetworkingService, CustomListDataService],
  standalone: false,
})
export class FavoriteLocationsComponent implements OnInit {
  public favoriteLists$ = this.store.select(getFavoriteLists);
  public selectedList: FavoriteList | undefined;

  constructor(
    private readonly customListEditor: CustomListEditorService,
    private readonly dataService: CustomListDataService,
    private readonly snackBar: MatSnackBar,
    private readonly matDialog: MatDialog,
    private readonly store: Store
  ) {}

  ngOnInit(): void {
    this.store.dispatch(loadCities());
  }

  onListDelete($event: FavoriteList) {
    if (!$event.id) {
      return;
    }
    this.store.dispatch(deleteList({ list: $event }));
  }

  onListCopy($event: Partial<FavoriteList>) {
    if (!$event.id) {
      return;
    }
    this.store.dispatch(
      copyList({
        list: $event,
      })
    );
  }

  onListEdit(isNew = false) {
    if (!this.selectedList && !isNew) {
      return;
    }
    const list = isNew ? { listName: '' } : this.selectedList;
    this.customListEditor
      .open(list as Partial<FavoriteList>)
      .afterClosed()
      .subscribe((data) => {
        if (!data) {
          return;
        }

        this.store.dispatch(changeList({ list: data }));
      });
  }

  public onListImport(): void {
    const dialogRef = this.openImportDialog();

    dialogRef.componentInstance.closingSubject$
      .pipe(
        switchMap(([ids, profile]) =>
          this.dataService.importCustomLists(ids, profile)
        )
      )
      .subscribe({
        next: (result) => {
          if (result) {
            dialogRef.close();
            this.showSnackbar(true);
          } else {
            this.showSnackbar(false);
          }
        },
        complete: () => this.store.dispatch(loadLists()),
      });
  }

  onHover(list: FavoriteList) {
    this.selectedList = list;
  }

  onLeave() {
    this.selectedList = undefined;
  }

  public trackByFnGroup(index: number) {
    return index;
  }

  private showSnackbar(success: boolean): void {
    const message = success
      ? `Your location lists have been imported.`
      : `Your location lists failed to import.<br> Please try again later. If the <br> problem persists, please contact <br> customer support.`;

    this.snackBar.openFromComponent(ToastComponent, {
      duration: 5000,
      data: { type: success ? 'success' : 'fail', message },
    });
  }

  private openImportDialog(): MatDialogRef<ImportListDialogComponent> {
    return this.matDialog.open(ImportListDialogComponent, {
      minWidth: '370px',
      height: 'auto',
      autoFocus: false,
      panelClass: ['firebird-dialog-panel'],
    });
  }
}
